
import { useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export const useUpdatePlan = (refreshData: () => void) => {
  const { toast } = useToast();

  // Function to update customer subscription status
  return useCallback(async (subscriptionId: string, newPlan: string) => {
    if (!subscriptionId) {
      toast({
        title: 'Update failed',
        description: 'No subscription record found for this user',
        variant: 'destructive',
      });
      return false;
    }

    try {
      const { error } = await supabase
        .from('subscriptions')
        .update({ plan: newPlan })
        .eq('id', subscriptionId);
      
      if (error) {
        console.error('Error updating subscription:', error);
        toast({
          title: 'Update failed',
          description: error.message,
          variant: 'destructive',
        });
        return false;
      }

      toast({
        title: 'Status updated',
        description: `Customer plan changed to ${newPlan}`,
      });

      // Refresh data to show the updated status
      refreshData();
      return true;
    } catch (err: any) {
      console.error('Error in update process:', err);
      toast({
        title: 'Update failed',
        description: err.message || 'An error occurred while updating the subscription',
        variant: 'destructive',
      });
      return false;
    }
  }, [toast, refreshData]);
};
